export const CA = "5vAExw5RGMqsxUTUoX2UByh1vi4U4UoLL4fguaMEpump";
export const BUY_URL = `https://pump.fun/coin/${CA}`;
export const X_URL = "https://x.com/datbihgahonsol?s=21";
export const TIKTOK_SEARCH_URL =
  "https://www.tiktok.com/search?q=dat%20bih%20gah";

export const LOGO_URL = "/assets/style_ref.jpeg";
export const BG_URL = "/assets/background.jpeg";

export const AUDIO_TUH = "/assets/dat_bih_tuh.mp3";
export const AUDIO_GAH = "/assets/dat_bih_gah.mp3";

export const TIKTOKS = [
  {
    id: "7644664323956067614",
    user: "espn",
    likes: "VIRAL",
    url: "https://www.tiktok.com/@espn/video/7644664323956067614",
  },
  {
    id: "7651678537044249870",
    user: "brogan.berry",
    likes: "VIRAL",
    url: "https://www.tiktok.com/@brogan.berry/video/7651678537044249870",
  },
  {
    id: "7647332368818162975",
    user: "itsforeignclipzz",
    likes: "VIRAL",
    url: "https://www.tiktok.com/@itsforeignclipzz/video/7647332368818162975",
  },
  {
    id: "7646907108746743070",
    user: "brainrotboy90",
    likes: "VIRAL",
    url: "https://www.tiktok.com/@brainrotboy90/video/7646907108746743070",
  },
  {
    id: "7651960856544169238",
    user: "therockpete",
    likes: "VIRAL",
    url: "https://www.tiktok.com/@therockpete/video/7651960856544169238",
  },
];
